module.exports ={
   // devURL: process.env.REACT_APP_DEV_BANKEND_PORT+'/api',
    devURL:'http://localhost:5000/api',
    prodURL:process.env.REACT_APP_PROD_BANKEND_PORT+'/api',
};